enum BillingBackend {
  st = 'st',
  gh = 'gh',
  mb = 'mb'
}

export default BillingBackend
